import type { PhoneLineList } from '@inbound/contract';

import { apiSlice } from './api-slice.js';

/** The inbound lines, for the filters that name them. They change rarely. */
export const linesApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getLines: build.query<PhoneLineList, void>({
      query: () => ({ url: '/lines' }),
      keepUnusedDataFor: 600,
    }),
  }),
});

export const { useGetLinesQuery } = linesApi;
